import Vue from 'vue'
import _ from 'lodash'

/*
  how to use:
    v-gl-focus="true"
*/
Vue.directive('gl-focus', {
  // on insert
  inserted (el) {
    // wait for the dom to settle
    Vue.nextTick(() => {
      // if element may be focused -> focus it
      if (_.isObject(el) && _.isFunction(el.focus)) {
        el.focus()
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-focus.js